import Text from 'components/Text';
import type { Field, HeadingLevel } from 'models/sitecore';

interface Props {
	className?: string;
	description: Field<string>;
	heading: Field<string>;
	headingLevel?: HeadingLevel;
}

export default function ContentHeading({
	className,
	description,
	heading,
	headingLevel = 'h2',
}: Props) {
	return (
		<div className={className}>
			<Text as={headingLevel} field={heading} />
			<Text as="pLarge" field={description} />
		</div>
	);
}
ContentHeading.displayName = 'ContentHeading';
